__turbopack_context__.v({
  "container": "EventLikedToast-module-scss-module__bVEUxG__container",
  "link": "EventLikedToast-module-scss-module__bVEUxG__link",
  "message": "EventLikedToast-module-scss-module__bVEUxG__message",
});
